export default __webpack_public_path__ + "static/media/pathfinder.6ff470ad.png";